import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function accountReducer(state = initialState.account, action) {
  switch (action.type) {
    case types.FETCH_ACCOUNT:
      return Object.assign({}, state, {
        loading: true,
        error: null
      });
    case types.FETCH_ACCOUNT_SUCCESS:
      return Object.assign({}, state, {
        data: action.data,
        hasAvailableOpportunities: {value: false, loading: true},
        loading: false,
        error: null
      });
    case types.FETCH_ACCOUNT_FAILURE:
      return Object.assign({}, state, {
        data: null,
        loading: false,
        error: action.error || 'Error loading account'
      });

    case types.MARK_DSA_AS_CLOSED_SUCCESS:
      return handleMarkDSAClosedSuccess(state, action);

    case types.MARK_DSA_AS_PRESENTED_SUCCESS:
      return handleMarkDSAPresentedSuccess(state, action);

    case types.UPDATE_DSA:
      return handleUpdateDSARequest(state, action);

    case types.CLONE_DSA:
    case types.CONVERT_DSA:
      return handleCloneDSA(state, action);
    case types.CLONE_DSA_SUCCESS:
    case types.CONVERT_DSA_SUCCESS:
      return handleCloneDSASuccess(state, action);

    case types.FETCH_OPPORTUNITIES_SUCCESS:
      return Object.assign({}, state, {
        hasAvailableOpportunities: {value: (state.hasAvailableOpportunities || {}).value || (action.data.records && action.data.records.length > 0), loading: false},
        availableOpportunities: action.data.records
      });
    case types.LINK_OPPORTUNITY_SUCCESS:
      return handleLinkOpportunitySuccess(state, action);
    case types.UNLINK_OPPORTUNITY_SUCCESS:
      return handleUnlinkOpportunitySuccess(state, action);

    default:
      return state;
  }
}

/*
 * Maps over each dsa and
 * returns the new state.
 */
function mapDSAs(state, callback) {
  let newState = {...state};
  let newData = JSON.parse(JSON.stringify(newState.data));
  newData.dsas = newData.dsas.map(callback);
  newState.data = newData;
  return newState;
}

function handleMarkDSAClosedSuccess(state, action) {
  return mapDSAs(state, dsa => {
    if (dsa.id === action.dsaId) {
      dsa.state = 'closed';
    }

    return dsa;
  });
}

function handleMarkDSAPresentedSuccess(state, action) {
  return mapDSAs(state, dsa => {
    if (dsa.id === action.dsaId) {
      dsa.presented = true;
      dsa.presentedDate = new Date();
    }

    return dsa;
  });
}

function handleUpdateDSARequest(state, action) {
  return mapDSAs(state, dsa => {
    if (dsa.id === action.dsaId) {
      return Object.assign({}, dsa, action.updates);
    }

    return dsa;
  });
}

function handleCloneDSA(state, action) {
  return mapDSAs(state, dsa => {
    if (dsa.id === action.dsaId) {
      dsa[getLoadingProperty(action)] = true;
    }

    return dsa;
  });
}

function handleCloneDSASuccess(state, action) {
  let newState = mapDSAs(state, dsa => {
    dsa[getLoadingProperty(action)] = undefined;
    return dsa;
  });

  let newData = JSON.parse(JSON.stringify(newState.data));
  newData.dsas = newData.dsas.concat([action.data.dsa]);
  newState.data = newData;
  return newState;
}

function handleLinkOpportunitySuccess(state, action) {
  let newData = Object.assign({}, state.data);
  let availableOpportunities = state.availableOpportunities || [];
  let opportunity = availableOpportunities.find(o => action.data.opportunity__c === o.sfid) || {};
  newData.dsaOpportunities = newData.dsaOpportunities.concat([action.data]);
  newData.opportunities = newData.opportunities.concat([opportunity]);
  return Object.assign({}, state, {data: newData});
}

function handleUnlinkOpportunitySuccess(state, action) {
  let newData = Object.assign({}, state.data);
  let opportunities = newData.opportunities.concat(state.availableOpportunities || []);
  let opportunity = opportunities.find(o => o.id === parseInt(action.data.opportunityid));
  let dsa = newData.dsas.find(dsa => dsa.id === parseInt(action.data.dsaid));

  newData.dsaOpportunities = newData.dsaOpportunities.filter(linkedOpp => {
    if (linkedOpp.opportunity__c === opportunity.sfid) {
      let linkedOppExternalId = linkedOpp.ssep_summary__r__ssep_summary_id__c;
      return !(dsa.id === parseInt(linkedOppExternalId) || dsa.uuid === linkedOppExternalId);
    }
    return true;
  });

  return Object.assign({}, state, {data: newData});
}

function getLoadingProperty(action) {
  switch (action.type) {
    case 'CONVERT_DSA':
    case 'CONVERT_DSA_SUCCESS':
      return 'converting';
    case 'CLONE_DSA':
    case 'CLONE_DSA_SUCCESS':
      return 'cloning';
  }
}



// WEBPACK FOOTER //
// ./src/reducers/accountReducer.js